"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedAssetType = void 0;
// eslint-disable-next-line import/prefer-default-export
var CachedAssetType;
(function (CachedAssetType) {
    CachedAssetType["TEXT"] = "text";
    CachedAssetType["QUILT"] = "quilt";
    CachedAssetType["PAGES"] = "pages";
    CachedAssetType["THEME"] = "theme";
    CachedAssetType["COMPONENT"] = "component";
    CachedAssetType["WRAPPER"] = "quiltWrapper";
    CachedAssetType["FIELD"] = "field";
    CachedAssetType["ENTITY"] = "entity";
    CachedAssetType["PAGE_SCRIPTS"] = "pageScripts";
})(CachedAssetType || (exports.CachedAssetType = CachedAssetType = {}));
//# sourceMappingURL=enums.js.map